/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { theme, pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- EXPORT : FORM : FIELD : LABEL : STYLES --------------- ++++++++++ */
export default {
	label: {
		color: theme.color.supporting.dark.swatch,
		display: 'block',
		fontSize: pxToEm(16),
		marginBottom: pxToEm(5),
		position: 'relative',
		zIndex: '1'
	}
};
